import { fetchConfigurations, queryOrder as queryOrderRoute } from "./http/api";
import { request } from "./index";

// pricingservice：定价、订单、会员相关接口集合。
// 已被 OpenAPI 覆盖且仍在使用的方法会内部委托给 `@apis/http/api` 的 defineRoute；
// 未覆盖且仍被使用的方法保留旧 `request` 实现；未使用的方法已删除。

// ===== 已迁移到 defineRoute（保留对外签名） =====

const queryOrder = async <T>(reqData: unknown) => {
  return (await queryOrderRoute({ orderId: String(reqData) } as any)) as unknown as T;
};

const fetchMembershipPackages = async <T>() => {
  const data = [{ key: "membership.price" }];
  return (await fetchConfigurations(data as any)) as unknown as T;
};

// ===== 保留：未在 OpenAPI 覆盖但仍被使用 =====

const fetchIndProducts = async <T>() => {
  return request<T>({ method: "post", url: `/pricing/others` });
};

const createOrder = async <T>(reqData: unknown) => {
  return request<T>({ method: "post", url: `/order/createOrder`, data: reqData });
};

const getFeture = async <T>(reqData: unknown) => {
  return request<T>({ method: "post", url: `/user/features`, data: reqData });
};

const fetchV1Memberships = async <T>(reqData: { source: string; dataCountry: string; sourceVersion?: string }) => {
  return request<T>({ method: "post", url: `/pricing/v1/memberships`, data: reqData });
};

export default {
  fetchIndProducts,
  createOrder,
  getFeture,
  queryOrder,
  fetchMembershipPackages,
  fetchV1Memberships,
};
